export default "__VITE_ASSET__mHu$dRln__"